import AWS from 'aws-sdk';
import { ACCESS_KEY, REGION, S3_BUCKET_NAMES, SECRET_ACCESS_KEY } from '../../defines';

AWS.config.update({
  accessKeyId: ACCESS_KEY,
  secretAccessKey: SECRET_ACCESS_KEY,
});

const publicBucket = new AWS.S3({
  params: { Bucket: S3_BUCKET_NAMES.public },
  region: REGION,
});

const privateBucket = new AWS.S3({
  params: { Bucket: S3_BUCKET_NAMES.private },
  region: REGION,
});

export const uploadPublicFile = async (file: File, path: string, progressCallback: (progress: number) => void) => {
  try {
    const params = {
      Body: file,
      Bucket: S3_BUCKET_NAMES.public,
      Key: path,
    };
    publicBucket
      .putObject(params)
      .on('httpUploadProgress', (evt) => {
        const progress = Math.round((evt.loaded / evt.total) * 100);
        progressCallback?.(progress);
      })
      .send((err) => {
        if (err) {
          console.log('[S3 - uploadPublicFile] Error:', err);
        }
      });
  } catch (error) {
    console.log('[S3 - uploadPublicFile] Error:', error);
  }
};

export const uploadPrivateFile = async (file: File, path: string, progressCallback: (progress: number) => void) => {
  try {
    const params = {
      ACL: 'private',
      Body: file,
      Bucket: S3_BUCKET_NAMES.private,
      Key: path,
    };
    privateBucket
      .putObject(params)
      .on('httpUploadProgress', (evt) => {
        const progress = Math.round((evt.loaded / evt.total) * 100);
        progressCallback?.(progress);
      })
      .send((err) => {
        if (err) {
          console.log('[S3 - uploadPrivateFile] Error:', err);
        }
      });
  } catch (error) {
    console.log('[S3 - uploadPrivateFile] Error:', error);
  }
};

export const getPresignedUrl = (path: string, callback: (url: string) => void) => {
  try {
    const params = { Key: path, Expires: 24 * 60 * 60 };
    privateBucket.getSignedUrl('getObject', params, (err, url) => {
      callback?.(url);
    });
  } catch (error) {
    console.log('[S3 - getPrivateFileUrl] Error:', error);
  }
};

/** Presigned URL for a HEAD request, used to read `Content-Length` without downloading the body. */
export const getPresignedHeadUrl = (path: string, callback: (url: string) => void) => {
  try {
    const params = { Key: path, Expires: 24 * 60 * 60 };
    privateBucket.getSignedUrl('headObject', params, (err, url) => {
      callback?.(url);
    });
  } catch (error) {
    console.log('[S3 - getPresignedHeadUrl] Error:', error);
  }
};
